export default __webpack_public_path__ + "static/media/enjoyment.27851063.svg";